import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Set Password icon. Exported from Figma (Bombiix 2026). */
const SetPasswordIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M3.33398 10.0013C3.33398 7.48714 3.33398 6.23007 4.11503 5.44902C4.89608 4.66797 6.15316 4.66797 8.66732 4.66797H11.334C13.8481 4.66797 15.1052 4.66797 15.8863 5.44902C16.6673 6.23007 16.6673 7.48714 16.6673 10.0013C16.6673 12.5155 16.6673 13.7725 15.8863 14.5536C15.1052 15.3346 13.8481 15.3346 11.334 15.3346H8.66732C6.15316 15.3346 4.89608 15.3346 4.11503 14.5536C3.33398 13.7725 3.33398 12.5155 3.33398 10.0013Z"
      stroke="currentColor"
    />
    <path
      d="M7.99935 9.9987C7.99935 10.3669 7.70087 10.6654 7.33268 10.6654C6.96449 10.6654 6.66602 10.3669 6.66602 9.9987C6.66602 9.63051 6.96449 9.33203 7.33268 9.33203C7.70087 9.33203 7.99935 9.63051 7.99935 9.9987Z"
      fill="currentColor"
    />
    <path
      d="M10.6673 9.9987C10.6673 10.3669 10.3688 10.6654 10.0007 10.6654C9.63246 10.6654 9.33398 10.3669 9.33398 9.9987C9.33398 9.63051 9.63246 9.33203 10.0007 9.33203C10.3688 9.33203 10.6673 9.63051 10.6673 9.9987Z"
      fill="currentColor"
    />
    <path
      d="M13.3333 9.9987C13.3333 10.3669 13.0349 10.6654 12.6667 10.6654C12.2985 10.6654 12 10.3669 12 9.9987C12 9.63051 12.2985 9.33203 12.6667 9.33203C13.0349 9.33203 13.3333 9.63051 13.3333 9.9987Z"
      fill="currentColor"
    />
  </svg>
);

export default SetPasswordIcon;
